import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";

import Layout from "../components/chat/Layout";

class Chat extends Component {
  state = {};

  render() {
    return (
      <Fragment>
        <Layout title="ANIPLUS Live Chat" />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Chat));
